import { ActionTypes } from "@/App/constants/actionTypes";
import { Action } from "@/App/actions";
import { ProductListTypes } from "@/types";

export interface ProductListGetState {
  productList: ProductListTypes.ProductListSearchResponse;
}

const DEFAULT_PRODUCT_LIST_GET_STATE: ProductListGetState = {
  productList: {
    results: [],
    result_count: "",
  },
};

export default (state: ProductListGetState = DEFAULT_PRODUCT_LIST_GET_STATE, action: Action): {} => {
  if (action.type === ActionTypes.GET_PRODUCT_LIST_RESULTS) {
    return {
      ...state,
      productList: action.payload,
    };
  } else {
    return state;
  }
};
